import { render, staticRenderFns } from "./productionSpotInfo.vue?vue&type=template&id=fd48f9b0&scoped=true"
import script from "./productionSpotInfo.vue?vue&type=script&lang=js"
export * from "./productionSpotInfo.vue?vue&type=script&lang=js"
import style0 from "./productionSpotInfo.vue?vue&type=style&index=0&id=fd48f9b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd48f9b0",
  null
  
)

export default component.exports